/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

/* eslint-disable */
import React from 'react';
import { Tabs, message, Tooltip } from 'antd';
import { WechatOutlined } from '@ant-design/icons';
import Header from '../components/header';
import PasswordForm from './components/password-form';
import MessageForm from './components/massage-form';
import LoginByFollowWechat from './components/wechat';
import { stringify } from '../utils/qs';
import API from '../services';
import { encrypt } from '../utils/encrypt';
import { StyledLogin } from './style';
import accountLoginPng from './imgs/account-login.png';
import qrcodeLoginPng from './imgs/qrcode-login.png';

const TabPane = Tabs.TabPane;
const noop = () => {};

type LoginProps = {
  changeView: (...args: any[]) => any;
  onClose?: (...args: any[]) => any;
  afterLogin?: (...args: any[]) => any;
};

type LoginState = any;

class Login extends React.Component<LoginProps, LoginState> {
  messageRef: any;
  passwordRef: any;

  state = {
    showCaptcha: false,
    passwordSubmitting: false,
    messageSubmitting: false,
    showWechatPublic: true,
    tabKey: '',
  };

  handleSubmit = ({ current }: any, formName: any) => {
    this.handleLogin(current, formName);
  };

  handleLogin = (form: any, formName: any) => {
    let values = form.getFieldsValue();
    if (formName === 'message') {
      values = { ...values, isSlide: true, identityType: 'MOBILE_SMS' };
    }
    this.setState({ [`${formName}Submitting`]: true });

    API.login(this.generateParams(values, formName)).then((response: any) => {
      const result = response?.content?.result;
      this.setState({ [`${formName}Submitting`]: false });

      if (result !== 'SUCCESS') {
        if (formName === 'password' && this.state.showCaptcha) {
          // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          this[`${formName}Ref`].current.resetCaptcha();
        }
      }

      switch (result) {
        case 'SUCCESS':
          if (typeof this.props.afterLogin === 'function') {
            this.props.afterLogin();
          }
          break;
        case 'FAIL':
          form.setFields([
            {
              name: 'password',
              value: values.password,
              errors: ['账号密码不匹配'],
            },
          ]);
          break;
        case 'NOTEXIST':
          form.setFields([
            {
              name: 'password',
              value: values.password,
              errors: ['账号密码不匹配'],
            },
          ]);
          break;
        case 'NOTEXIST_CODE':
          form.setFields([
            {
              name: 'password',
              errors: ['请输入正确的短信验证码'],
            },
          ]);
          break;
        case 'LOCKED':
          message.warning('账号已被锁定，请联系在线客服 400 082 0386！');
          break;
        case 'CODE_REQUIRED':
          if (formName === 'message') {
            // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            this[`${formName}Form`].resetCaptcha();
            form.setFields([
              {
                name: 'password',
                errors: ['请输入正确的短信验证码'],
              },
            ]);
          } else if (!this.state.showCaptcha) {
            this.setState({ showCaptcha: true });
            form.setFields([
              {
                name: 'position',
                errors: ['请向右滑动完成拼图'],
              },
            ]);
          } else {
            form.setFields([
              {
                name: 'password',
                value: values.password,
                errors: ['账号密码不匹配'],
              },
            ]);
          }
          break;
        case 'ERROR_CODE':
          form.setFields([
            {
              name: 'password',
              errors: ['请向右滑动完成拼图'],
            },
          ]);
          break;
        default:
          form.setFields([
            {
              name: 'password',
              value: values.password,
              errors: ['账号密码不匹配'],
            },
          ]);
      }
    });
  };
  // eslint-disable-next-line no-unused-vars
  generateParams = (values: any, formName: any) => {
    const obj: Record<string, string> = {};
    Object.keys(values).forEach((k) => {
      const v = values[k];
      if (v && ['username', 'password', 'isSlide', 'rememberMe', 'identityType'].includes(k)) {
        obj[k] = v;
      }
    });
    obj.username = encrypt(obj.username.trim());
    obj.password = encrypt(obj.password);

    return stringify(obj);
  };

  sendCode = ({ mobile, offset, source = 'rrp' }: any) =>
    API.sendSms(stringify({ mobile, offset, source })).then((response: any) => {
      // 兼容不同版本接口
      // 1. code: 0, content: true发送成功，false发送失败
      // 2. code: 0发送成功，其余发送失败
      if (response.code === 0 && response.content !== false) {
        message.success('短信验证码已发送成功');
      } else {
        message.error('短信验证码已发送失败');
      }
      return response;
    });

  setFormRef = (name: any, form: any) => {
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    this[`${name}Form`] = form;
  };

  handleWechatClick = (e: any) => {
    e.preventDefault();

    API.logout().then(() => {
      API.getWechatLogin().then((response: any) => {
        const url = response.content;
        const { location } = window;

        location.href = url.replace('#wechat_redirect', encodeURIComponent(location.href));
      });
    });
  };

  handleWeiboClick = (e: any) => {
    e.preventDefault();

    API.getWeiboLogin().then((response: any) => {
      const url = response.content;
      const { location } = window;

      location.href = url.replace('#wechat_redirect', encodeURIComponent(location.href));
    });
  };

  handleRegisterClick = (e: any) => {
    e.preventDefault();

    this.props.changeView('register');
  };

  renderAccountLogin = () => (
    <div className="account-login-block">
      <Tabs
        centered
        defaultActiveKey="password"
        tabBarGutter={0}
        animated={false}
        onChange={(activeKey) => {
          this.setState({ tabKey: activeKey });
        }}
      >
        <TabPane tab="密码登录" key="password">
          <PasswordForm
            ref={(form) => this.setFormRef('password', form)}
            wrappedComponentRef={(ref) => (this.passwordRef = ref)}
            onSubmit={this.handleSubmit}
            showCaptcha={this.state.showCaptcha}
            submitting={this.state.passwordSubmitting}
          />
        </TabPane>
        <TabPane tab="短信验证码登录" key="message">
          <MessageForm
            ref={(form) => this.setFormRef('message', form)}
            wrappedComponentRef={(ref) => (this.messageRef = ref)}
            sendCode={this.sendCode}
            onSubmit={this.handleSubmit}
            submitting={this.state.messageSubmitting}
          />
        </TabPane>
      </Tabs>
      <div className="dyc-login-others">
        <div className="title">
          <span>第三方账号登陆</span>
        </div>
        <div className="icons">
          <span onClick={this.handleWechatClick}>
            <WechatOutlined />
          </span>
        </div>
        <p>
          没有帐号？
          <a onClick={this.handleRegisterClick}>立即注册</a>
        </p>
      </div>
    </div>
  );

  toggleLoginWay = () => {
    this.setState(({ showWechatPublic }: any) => ({
      showWechatPublic: !showWechatPublic,
    }));
  };

  render() {
    const { showWechatPublic, tabKey } = this.state;
    const switchPng = showWechatPublic ? accountLoginPng : qrcodeLoginPng;
    const tips = showWechatPublic ? '账号登录在这里' : '扫码登录更安全';
    const blockClass = showWechatPublic ? '' : 'show-account-block';

    return (
      <StyledLogin>
        <Header onClose={this.props.onClose} />
        <div className={`dyc-login-main dyc-login-register-main ${blockClass}`}>
          {showWechatPublic ? (
            <div className="qrcode-login-block">
              <LoginByFollowWechat
                onRegister={this.props.changeView}
                afterLogin={this.props.afterLogin}
              />
            </div>
          ) : (
            this.renderAccountLogin()
          )}
          <div className="login-switch-btn" onClick={this.toggleLoginWay}>
            {/* 加tabKy 为了让tooltip重新定位 */}
            <Tooltip title={tips} visible placement="leftTop" key={tabKey}>
              <img src={switchPng} alt="" />
            </Tooltip>
          </div>
        </div>
      </StyledLogin>
    );
  }
}

export default Login;
